// @flow
import React, { PureComponent } from 'react';
import type { ParticipantType } from 'types/Competition';
import { Link } from 'react-router-dom';
import { handleTagEvent } from 'utils/tagManagerUtils';

export type StateProps = {
  slug: string,
  participants: Array<ParticipantType>,
  ranking: {
    poules: Array<any>
  }
};

type Props = {
  pouleId: number
} & StateProps;

class CompetitionResultRanking extends PureComponent<Props> {
  renderRowRanking = (clubsRanked: Array<any>): any => {
    const { participants } = this.props;

    return clubsRanked.filter(clubRanked => !clubRanked.equipe.nom.includes('EXEMPT'))
    .map((clubRanked, index) => {
      const club = participants.filter(participant => participant.nom === clubRanked.equipe.nom);
      let clubLogo = '/img/logo/placeholder-club.png';
      if (club.length > 0) {
        if (club[0].embleme) {
          clubLogo = club[0].embleme;
        }
      }

      const childrenLink = (
        <p>
          <img src={clubLogo} alt={clubRanked.equipe.nom} width="32" height="32" />
          {clubRanked.equipe.nom}
        </p>
      );

      return (
        <tr key={index}>
          <td className="ranking__count">{clubRanked.position}</td>
          <td className="ranking__name">
            {club.length > 0 && this.renderLink(club[0].url_type, club[0].url, childrenLink, clubRanked.equipe.nom)}
            {club.length === 0 && childrenLink}
          </td>
          <td className="ranking__point">{clubRanked.pointTerrain} </td>
          <td className="ranking__stat">{clubRanked.joues} </td>
          <td className="ranking__stat">{clubRanked.gagnes}</td>
          <td className="ranking__stat">{clubRanked.nuls}</td>
          <td className="ranking__stat">{clubRanked.perdus}</td>
          <td>
            <ul className="ranking__history">
              {clubRanked.last_matchs &&
                clubRanked.last_matchs.map((match, index) => {
                  return <li key={index} className={match.win > 0 ? 'has-win' : ''} title={match.name}></li>;
                })}
            </ul>
          </td>
        </tr>
      );
    });
  };

  renderLink(url_type: string, url: string, childrenLink: any, name: string) {
    if (url_type === 'interne') {
      return (
        <Link to={url || ''} onClick={handleTagEvent('module classement', `clic ${name}`, window.location.pathname)}>
          {childrenLink}
        </Link>
      );
    } else if (url_type === 'externe') {
      return (
        <a
          href={url}
          onClick={handleTagEvent('module classement', `clic ${name}`, window.location.pathname)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {childrenLink}
        </a>
      );
    }
    return (
      <a onClick={handleTagEvent('module classement', `clic ${name}`, window.location.pathname)}>{childrenLink}</a>
    );
  }

  render() {
    const { ranking, slug } = this.props;
    let rankingFiltered;

    if (this.props.pouleId) {
      rankingFiltered = ranking.poules.filter(poule => poule.pouleId === this.props.pouleId);
    } else {
      rankingFiltered = ranking.poules;
    }

    if (rankingFiltered.length === 0) {
      return (
        <div className="block-competition mb-6 mb-md-7">
          <h3 className="mb-3">Classement</h3>
          <span>Pas de classement</span>
          {slug && (
            <a
              href={`https://competitions.ffr.fr/competitions/${slug}/classements.html`}
              className="link-chevron link-chevron--blue link-chevron--inline"
              data-label=""
              target="blank"
              rel="noopener noreferer"
            >
              <span>Voir le classement complet</span>
              <i className="icon icon-external"></i>
            </a>
          )}
        </div>
      );
    }

    return (
      <div className="block-competition">
        <h3 className="mb-3">Classement</h3>
        <div className="ranking box box--smoke">
          <table>
            <thead>
              <tr>
                <th className="ranking__count">
                  <abbr title="Classement">#</abbr>
                </th>
                <th className="ranking__name">Clubs</th>
                <th className="ranking__point">
                  <abbr title="Points">Pts</abbr>
                </th>
                <th className="ranking__stat">
                  <abbr title="Joués">J</abbr>
                </th>
                <th className="ranking__stat">
                  <abbr title="Gagnés">G</abbr>
                </th>
                <th className="ranking__stat">
                  <abbr title="Nuls">N</abbr>
                </th>
                <th className="ranking__stat">
                  <abbr title="Perdus">P</abbr>
                </th>
                <th className="ranking__last">
                  <abbr title="5 Derniers matchs">5 derniers</abbr>
                </th>
              </tr>
            </thead>
            <tbody>{this.renderRowRanking(rankingFiltered[0].classement)}</tbody>
          </table>
        </div>
        {slug && (
          <a
            href={`https://competitions.ffr.fr/competitions/${slug}/classements.html`}
            className="link-chevron link-chevron--blue link-chevron--inline"
            data-label=""
            target="blank"
            rel="noopener noreferer"
          >
            <span>Voir le classement complet</span>
            <i className="icon icon-external"></i>
          </a>
        )}
      </div>
    );
  }
}

export default CompetitionResultRanking;
